module.exports = __webpack_public_path__ + "img/renewable-energy.4514831b.svg";